import { IInstanceComponentBase, InstanceComponentBase } from "../../shared/instanceComponentBase";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { IProductReviewsAggregate, IReviewsAggregate, IReviewsSummary } from "./reviewsAggregate";
import { IReviewWidgetAggregateComponent, ReviewWidgetAggregateComponent } from "./reviewWidgetAggregateComponent";
import { IReviewWidgetAggregatePanel, ReviewWidgetAggregatePanel } from "./reviewWidgetAggregatePanel";
import { IReviewWidgetAggregatePanelBase, ReviewWidgetAggregatePanelBase } from "./reviewWidgetAggregatePanelBase";
import { IReviewWidgetFeatureAggregateComponent, ReviewWidgetFeatureAggregateComponent } from "./reviewWidgetFeatureAggregateComponent";
import { IReviewWidgetSummaryComponent, ReviewWidgetSummaryComponent } from "./reviewWidgetSummaryComponent";

export interface IReviewWidgetAggregatePanelProduct extends IReviewWidgetAggregatePanelBase   {
    reviewWidgetFeatureAggregateComponent: IReviewWidgetFeatureAggregateComponent;
    reviewsAggregate: IProductReviewsAggregate;
    updateReviewsAggregate:(reviewsAggregate: IProductReviewsAggregate) => void;
    update:(reviewsAverage: number, totalReviews: number, reviewsSummary: IReviewsSummary, qualityAverage: number, valueForMoneyAverage: number) => void;
}

export class ReviewWidgetAggregatePanelProduct extends ReviewWidgetAggregatePanelBase implements IReviewWidgetAggregatePanelProduct {
    public reviewWidgetFeatureAggregateComponent: IReviewWidgetFeatureAggregateComponent;
    public reviewsAggregate: IProductReviewsAggregate = {} as IProductReviewsAggregate;

    constructor(public htmlElement: HTMLElement) {
        super(htmlElement);

        this.createReviewWidgetFeatureAggregateComponent();

        this.setReviewsAggregate();
    }

     createReviewWidgetFeatureAggregateComponent():void{
        let reviewWidgetFeatureAggregateComponentElement: HTMLElement | null = this.getHtmlElementForReviewWidgetFeatureAggregateComponent();
        if (reviewWidgetFeatureAggregateComponentElement) {
            this.reviewWidgetFeatureAggregateComponent = new ReviewWidgetFeatureAggregateComponent(reviewWidgetFeatureAggregateComponentElement);
        }
    }
    
    getHtmlElementForReviewWidgetFeatureAggregateComponent():HTMLElement{
        let featureAggregateComponentElement: HTMLElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewWidgetFeatureAggregateComponent.reviewWidgetFeatureAggregateComponent))
        return featureAggregateComponentElement;
    }

    update(reviewsAverage: number, totalReviews: number, reviewsSummary: IReviewsSummary, qualityAverage: number, valueForMoneyAverage: number):void{
        this.updateBase(reviewsAverage, totalReviews, reviewsSummary);
        this.reviewWidgetFeatureAggregateComponent.update(qualityAverage, valueForMoneyAverage);
    }

    dispose() {

    }
}

